import { ROLES } from '../config/constants/contractStates';

export const getRoleName = (name) => {
  switch (name) {
    case 'lessor':
      return ROLES.LESSOR;
    case 'lessee':
      return ROLES.LESSEE;
    case 'codebtor':
      return ROLES.CODEBTOR;
    default:
      break;
  }
};

export const validateRutUsed = (formData, rut, inputName) => {
  const rutsArray = Object.entries(formData)
    .filter(value => value[0] !== inputName)
    .find(value => value[1] === rut);
  if (rutsArray && rutsArray[0]) return false;
  return true;
};

export const getInitialRuts = formData => {
  const signerRuts = {
    lessor_0_rut: formData.arrendador.rut,
    lessee_0_rut: formData.arrendatario.rut,
  };
  if (formData.arrendador?.personaJuridica?.rut) {
    signerRuts.lessor_0_companyRol = formData.arrendador.personaJuridica.rut;
  }
  if (formData.arrendatario?.personaJuridica?.rut) {
    signerRuts.lessee_0_companyRol = formData.arrendatario.personaJuridica.rut;
  }
  if (formData.arrendatarios && formData.arrendatarios[0]) {
    formData.arrendatarios.map((signer, i) => {
      signerRuts[`lessee_${i + 1}_rut`] = signer.rut;
      if (signer.personaJuridica?.rut) {
        signerRuts[`lessee_${i + 1}_companyRol`] = signer.personaJuridica.rut;
      }
    });
  }
  if (formData.codeudores && formData.codeudores[0]) {
    formData.codeudores.map((signer, i) => {
      signerRuts[`codebtor_${i}_rut`] = signer.rut;
      if (signer.personaJuridica?.rut) {
        signerRuts[`codebtor_${i}_companyRol`] = signer.personaJuridica.rut;
      }
    });
  }
  return signerRuts;
};